import CourseHeader, { CourseHeaderProps } from './CourseHeader';

export type { CourseHeaderProps };
export default CourseHeader;
